import { Button } from '@planuze/ui';
import { usePlansContent } from '../../content/sections/plans.js';
import { BulkSelectionBar } from '../bulk-selection-bar.js';

export function PlanBulkBar({
  selectedCount,
  busy,
  onArchive,
  onClear,
}: {
  readonly selectedCount: number;
  readonly busy: boolean;
  readonly onArchive: () => void;
  readonly onClear: () => void;
}) {
  const copy = usePlansContent().publicSection;
  if (selectedCount === 0) return null;
  return (
    <BulkSelectionBar
      selectedLabel={copy.bulkSelected(selectedCount)}
      clearLabel={copy.bulkClear}
      busy={busy}
      onClear={onClear}
    >
      <Button size="sm" variant="destructive" disabled={busy} onClick={onArchive}>
        {copy.bulkArchive}
      </Button>
    </BulkSelectionBar>
  );
}
